module.exports = __webpack_public_path__ + "img/icon-service.01f7202e.svg";